const MESSAGES_COPY = {
  title: 'Messages',
  unreadOnly: 'Unread only',
  searchPlaceholder: 'Search your book',
  emptyList: 'No conversations here',
  emptyThread: 'Select a conversation',
  openRecord: 'Open record',
  replyPlaceholder: 'Reply to',
  send: 'Send',
  warmIntroSent: 'Warm introduction sent',
  authorYou: 'You',
  authorConcierge: 'Concierge',
  blank: '—',
  notConfiguredTitle: 'Chat is not configured.',
  notConfiguredDescription: 'VITE_STREAM_CHAT_API_KEY is missing, so no thread can be opened.',
  errorTitle: 'Threads did not load.',
  errorDescription: 'Reload the page or try again in a moment.',
  sendFailed: 'The message was not sent. Your text is still in the box — try again.',
} as const;

const WARM_INTRO_COPY = {
  title: 'Warm introduction',
  permission: 'messages.view · concierge',
  subtitle: 'Written and sent by hand — the message is the introduction.',
  toLabel: 'To',
  clientLabel: 'Client profile to introduce',
  clientPlaceholder: 'Select a client',
  linkLabel: 'Profile link',
  linkPlaceholder: 'Paste the client profile link',
  linkHint: 'Embedded in the message below.',
  messageLabel: 'Message',
  messagePlaceholder: 'Write the introduction in your own words',
  send: 'Send introduction',
  footnote: 'One message to this Single — nothing else goes out.',
  errorCopy: 'The introduction was not sent. Nothing reached the Single.',
  alreadyAcquainted: 'This pair already knows each other — a like or an intro was sent before.',
  sent: 'Warm intro sent',
  roleChip: 'Single',
} as const;

const CONCIERGE_THREAD_COPY = {
  notMoved: 'Concierge changed, but the chat thread did not move. Reassign again to retry.',
  booksNotMoved: 'Books were handed over, but the chat threads did not move. Reassign the members to retry.',
  booksPartlyMoved: 'chat threads did not move to the new concierge. Reassign those members to retry.',
} as const;

const THREAD_PARAM = 'thread';

const CONCIERGE_CHANNEL_PREFIX = 'concierge-';

const ALREADY_ACQUAINTED_CODE = '23505';

const ALREADY_ACQUAINTED_INDEX = 'approaches_one_first_per_pair';

const MESSAGES_LAYOUT = {
  list: 'w-[360px]',
  conversation: 'flex-1 min-w-px',
  rail: 'w-[340px]',
} as const;

export {
  ALREADY_ACQUAINTED_CODE,
  ALREADY_ACQUAINTED_INDEX,
  CONCIERGE_CHANNEL_PREFIX,
  CONCIERGE_THREAD_COPY,
  MESSAGES_COPY,
  MESSAGES_LAYOUT,
  THREAD_PARAM,
  WARM_INTRO_COPY,
};
